export const DialogToastVariant = {
    SUCCESS: 'success',
    INFO: 'info',
    ERROR: 'error',
    WARNING: 'warning'
};

export const DialogToastDefaultDurationMs = 3000;

export const SET_DIALOG_TOAST = 'dialogToast/SET_DIALOG_TOAST';
export const CLOSE_DIALOG_TOAST = 'dialogToast/CLOSE_DIALOG_TOAST';
